<div class="app-modal-title">Confirm</div>
<div class="app-modal-content">
	<div class="content-message">
		{{message}}
	</div>
</div>
<div class="app-modal-footer">
	<button class="button-general" md-raised-button (click)="dialogRef.close('commit')">Commit</button>
	<button class="button-general" md-raised-button (click)="dialogRef.close('discard')">Discard</button>
	<button class="button-general" md-raised-button (click)="dialogRef.close(false)">Cancel</button>
</div>
